import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import VueScrollTo from 'vue-scrollto';
import { validators } from './helpers/validators.js';
import titleMixin from './mixins/titleMixin';


Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  duration: 1000,
  
});

const validateConfig = {
  aria: true,
  classNames: {},
  classes: true,
  events: 'input|blur|change|focus',
};

Vue.use(VeeValidate, validateConfig);
Validator.extend('validateABA', validators.validateABA);
Validator.extend('validateZip', validators.validateZip);
Validator.extend('validateAreaCode', validators.validateAreaCode);
Validator.extend('validateAge', validators.validateAge);

Vue.mixin(titleMixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
